@if (comparison) {
  <section class="results-section" data-testid="smart-results" aria-labelledby="results-title">
    <div class="results-heading">
      <div>
        <p class="eyebrow">תוצאות לפי סניף</p>
        <h2 id="results-title">מה נבחר עבור כל צורך</h2>
      </div>
      <span>{{ comparison.needCount }} צרכים · {{ comparison.branches.length }} סניפים</span>
    </div>

    @if (comparison.branches.length === 0) {
      <p class="card empty-state">אין תוצאות להצגה בעיר הזו.</p>
    } @else {
      <div class="branch-grid">
        @for (branch of comparison.branches; track branch.branchId; let first = $first) {
          <article class="branch-card" [class.best-branch]="first">
            <header class="branch-header">
              <div>
                @if (first) {
                  <span class="best-label">תוצאה ראשונה בדירוג</span>
                }
                <h3 dir="auto">{{ branch.chainName }} · {{ branch.branchName }}</h3>
                <p>
                  כיסוי {{ formatPercent(branch.coverage) }} ·
                  {{ branch.matchedCount }} נמצאו · {{ branch.missingCount }} חסרים
                </p>
              </div>
              <div class="totals">
                <strong>{{ formatMoney(branch.total, branch.currency) }}</strong>
                @if (hasUnapprovedSuggestions(branch.resolutions)) {
                  <span class="estimate-note">
                    מחיר משוער — כולל הצעות שמחייבות אישור
                  </span>
                }
                @if (branch.savings > 0) {
                  <span>
                    מדף {{ formatMoney(branch.shelfTotal, branch.currency) }} · חיסכון
                    {{ formatMoney(branch.savings, branch.currency) }}
                  </span>
                }
              </div>
            </header>

            <ul class="resolution-list">
              @for (resolution of branch.resolutions; track resolution.needId) {
                <li
                  class="resolution"
                  [class.catalog-suggestion]="resolution.approvalRequired"
                  [class.missing-resolution]="resolution.resolutionType === null"
                >
                  <div class="resolution-title">
                    <div>
                      <span class="requested-label">הצורך המבוקש</span>
                      <strong dir="auto">
                        {{ resolution.requestedText }} × {{ resolution.quantity }}
                      </strong>
                    </div>
                    <span class="state-badge" [attr.data-state]="resolution.resolutionType">
                      {{ resolutionLabel(resolution.resolutionType) }}
                    </span>
                  </div>

                  @if (resolution.selectedProductId != null) {
                    <div class="selected-product">
                      <span>המוצר שנבחר</span>
                      <strong dir="auto">{{ resolution.selectedProductName }}</strong>
                    </div>
                    <dl class="resolution-facts">
                      <div>
                        <dt>מדיניות</dt>
                        <dd>{{ needPolicyLabel(resolution.policy) }}</dd>
                      </div>
                      <div>
                        <dt>ביטחון התאמה</dt>
                        <dd>{{ confidenceLabel(resolution.confidence) }}</dd>
                      </div>
                      <div>
                        <dt>{{ resolution.soldByWeight ? 'מחיר לק״ג' : 'מחיר ליחידה' }}</dt>
                        <dd>{{ formatMoney(resolution.price, branch.currency) }}</dd>
                      </div>
                      <div>
                        <dt>סה״כ לשורה</dt>
                        <dd>{{ formatMoney(resolution.lineTotal, branch.currency) }}</dd>
                      </div>
                    </dl>

                    @if (resolution.promoPrice != null || resolution.promoLabel) {
                      <p class="promo" dir="auto">
                        <strong>מבצע</strong>
                        @if (resolution.promoPrice != null) {
                          <span>
                            מחיר מבצע
                            {{ formatMoney(resolution.promoPrice, branch.currency) }}
                          </span>
                        }
                        @if (resolution.promoLabel) {
                          <span>{{ resolution.promoLabel }}</span>
                        }
                        @if (resolution.promoKind) {
                          <span>סוג: {{ resolution.promoKind }}</span>
                        }
                        @if (resolution.shelfPrice != null) {
                          <span>
                            מחיר מדף {{ formatMoney(resolution.shelfPrice, branch.currency) }}
                          </span>
                        }
                      </p>
                    }

                    <p class="reason" dir="auto">
                      <strong>סיבת הבחירה:</strong> {{ resolution.reason }}
                    </p>

                    <div class="resolution-actions">
                      @if (resolution.approvalRequired) {
                        <button
                          type="button"
                          class="approve-button"
                          data-testid="approve-suggestion"
                          (click)="approve.emit(resolution)"
                          [disabled]="profileBusy || compareLoading"
                        >
                          אישור החלופה והרצה מחדש
                        </button>
                      }
                      <button
                        type="button"
                        class="lock-button"
                        data-testid="lock-exact"
                        (click)="lock.emit(resolution)"
                        [disabled]="busyNeedIds.has(resolution.needId) || compareLoading"
                      >
                        נעילה כמוצר מדויק
                      </button>
                    </div>
                  } @else {
                    <p class="missing-copy">לא נבחר מוצר לצורך הזה בסניף.</p>
                    @if (resolution.missingReason) {
                      <p class="reason" dir="auto">
                        <strong>סיבת החוסר:</strong> {{ resolution.missingReason }}
                      </p>
                    }
                  }
                </li>
              }
            </ul>
          </article>
        }
      </div>
    }
  </section>
}
